import AddModuleForm from 'components/form/super-admin/module/AddModuleForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'

export default class AddModule extends Component {
    render() {
        return (
            <>
             <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Add Module</h4>
                                <AddModuleForm/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
